import Injector from 'vue-inject';
import Debug from '@/util/debug';

const debug = Debug('service:LandingPage');

export const PAGE_WEB = 'webpage';
export const PAGE_FACEBOOK = 'facebookpage';

export default class LandingPageService {
  constructor() {
    this.types = [{
      value: PAGE_WEB,
    }, {
      value: PAGE_FACEBOOK,
    }];
  }

  getPageTypes() {
    debug.info('getPageTypes', this.types);

    return new Promise(resolve => resolve(this.types));
  }

  getDefault() {
    return this.getPageTypes()
      .then(types => {
        if (types.length) {
          return types[0];
        }

        throw new Error('No landing page types');
      });
  }
}

Injector.service('landingPageService', null, LandingPageService);



// WEBPACK FOOTER //
// ./src/services/LandingPageService.js